import { Navigate, Outlet, createBrowserRouter } from "react-router";
import { AuthProvider } from "./auth/AuthProvider.js";
import { ProtectedRoute } from "./auth/ProtectedRoute.js";
import { CanvasBenchmarkPage } from "./canvas/CanvasBenchmarkPage.js";
import { ProductionCanvasPage } from "./canvas/ProductionCanvasPage.js";
import { ChangePasswordPage } from "./routes/ChangePasswordPage.js";
import { GenerationAuditPage } from "./routes/GenerationAuditPage.js";
import { GenerationHistoryPage } from "./routes/GenerationHistoryPage.js";
import { LoginPage } from "./routes/LoginPage.js";
import { ProjectsPage } from "./routes/ProjectsPage.js";

function AuthenticatedApplication() {
  return (
    <AuthProvider>
      <Outlet />
    </AuthProvider>
  );
}

export const router = createBrowserRouter([
  {
    path: "/benchmark",
    element: <CanvasBenchmarkPage />
  },
  {
    element: <AuthenticatedApplication />,
    children: [
      {
        path: "/login",
        element: <LoginPage />
      },
      {
        element: <ProtectedRoute passwordChangeOnly />,
        children: [
          {
            path: "/change-password",
            element: <ChangePasswordPage />
          }
        ]
      },
      {
        element: <ProtectedRoute />,
        children: [
          {
            path: "/projects",
            element: <ProjectsPage />
          },
          {
            path: "/generations",
            element: <GenerationHistoryPage />
          },
          {
            path: "/admin/generations",
            element: <GenerationAuditPage />
          },
          {
            path: "/projects/:projectId",
            element: <ProductionCanvasPage />
          }
        ]
      },
      {
        path: "*",
        element: <Navigate to="/projects" replace />
      }
    ]
  }
]);
